module.exports = __webpack_public_path__ + "img/XingfengBao.71ecec24.jpg";